import {Injectable} from "@angular/core";

function _window(): any {
    return window;
}

@Injectable({
    providedIn: "root"
})
export class WindowRefService {
    public constructor() {
    }

    public get nativeWindow(): any {
        return _window();
    }

    public static getQueryString(): string {
        const query: string = _window().location.search;

        if (query && (query.length > 1)) {
            return query.slice(1);
        }

        return null;
    }

    public static setQueryString(query: string): void {
        const location = _window().location;
        _window().history.replaceState({ state: "REDIRECTED" }, "UNUSED", [location.protocol, "//", location.host, location.pathname, "?", query].join(""));
    }
}
